var topFilters = {

    make    : null,
    model   : null,
    year    : null,
    trim    : null,
    init : function (){

        $('.top-filters select.ajax-select').each(function(){

            var $select = $(this),
                data = $select.data(),
                options = {
                    placeholder:data.placeholder
                },
                $select_name = $select.attr('name');

            if(data.ajax){

                options = $.extend(false, options , {
                    ajax: {
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            var q = typeof(params.term)!=='undefined'?params.term:''
                            return {
                                route:data.ajax,
                                q: data.search+'=@'+q,
                                current_url : CURRENT_PATH,
                                additionals : {
                                    year    : fitmentSearch.year !== null   && typeof(fitmentSearch.year.id) !=='undefined' ? fitmentSearch.year.id : '',
                                    model   : fitmentSearch.model !== null  && typeof(fitmentSearch.model.id) !=='undefined' ? fitmentSearch.model.id : '',
                                    trim    : fitmentSearch.trim !== null   && typeof(fitmentSearch.trim.id) !=='undefined' ? fitmentSearch.trim.id : '',
                                    make    : fitmentSearch.make !== null   &&  typeof(fitmentSearch.make.id) !=='undefined' ? fitmentSearch.make.id : ''
                                },

                                page: params.page
                            };
                        },
                        processResults: function (data, params) {
                            params.page = params.page || 1;

                            return {
                                results: data.data,
                                pagination: {
                                    more: (params.page * 30) < data.total_count
                                }
                            };
                        },
                        cache: true
                    },
                    allowClear:true,
                    minimumInputLength: 0,
                    templateResult: function(d){
                        return d[data.search];
                    },
                    templateSelection: function(d){

                        if (data.id === '' ) { // adjust for custom placeholder values
                            return data.placeholder;
                        }

                        fitmentSearch[ $select_name ] = {
                            id:d['id'],
                            label: data.search
                        };
                        return d[data.search] || data.placeholder;
                    }
                });

                if($select.data('selected_value')){
                    $.ajax({
                        dataType: 'json',
                        data: {
                            route:data.ajax,
                            id:$select.data('selected_value')
                        },
                        error:function(){},
                        success:function(res){
                            $select.attr('placeholder',res.data[0][data.search]);
                            data.placeholder = res.data[0][data.search];
                            options.placeholder = res.data[0][data.search];

                            $select.html('<option value="'+res.data[0].id+'" selected>'+res.data[0][data.search]+'</option>');
                            $select.select2(options);
                        }
                    });
                }
            }			
			
            $(this).select2(options).on('select2:open', function () {
				$(this).closest('.form-group').addClass('filled');
			}).on('select2:close', function () {
				if( $(this).val() == '0' || $(this).val() == '' || $(this).val() == 'undefined' || $(this).val() == null ){
					$(this).closest('.form-group').removeClass('filled');           
				}       
			}).data('select2').$dropdown.addClass('top-filters-container');
			
        });
		
		$('.top-filters select.simple-select').each(function(){
			$(this).select2().on('select2:open', function () {
				$(this).closest('.form-group').addClass('filled');
			}).on('select2:close', function () {
				if( $(this).val() == '0' || $(this).val() == '' || $(this).val() == 'undefined' || $(this).val() == null ){
					$(this).closest('.form-group').removeClass('filled');           
				}       
			}).data('select2').$dropdown.addClass('top-filters-container');
		});
    }
};

$(function(){
    topFilters.init();
});	


